module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746f_logo_200x200.6c793c91.png";